// This file is auto-generated

import { Message, BinaryWriter, BinaryReader } from "google-protobuf";

import * as dep_1 from "./../tolemac/pub/filter";

export enum DocumentType {
    UNDEFINED_DocumentType = 0,
    /**
     * Facture
     */
    INVOICE = 1,
    /**
     * PIF
     */
    PIF = 2,
    /**
     * Convention
     */
    TRAINING_AGREEMENT = 3,
    /**
     * Contrat
     */
    CONTRACT = 4,
    /**
     * Att. Formation
     */
    TRAINING_CERTIFICATE = 5,
    /**
     * Att. Assiduité
     */
    ATTENDANCE_CERTIFICATE = 6,
    /**
     * Att. Admission
     */
    ADMISSION_CERTIFICATE = 7,
}
export interface IDocument {
    id?: number;
    trainingId?: number;
    intervalId?: number;
    type?: DocumentType;
    date?: number;

}
export class Document implements IDocument {

    id?: number;
    trainingId?: number;
    intervalId?: number;
    type?: DocumentType;
    date?: number;

    constructor(data?: Partial<IDocument>) {
        if (data)
            Object.keys(data).forEach(d => this[d] = data[d])
    }
}
export class MDocument extends Message implements Document {

    constructor(data?: Partial<IDocument>) {
        super();
        Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], []);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("id" in data && data.id != undefined) this.id = data.id;
            if ("trainingId" in data && data.trainingId != undefined) this.trainingId = data.trainingId;
            if ("intervalId" in data && data.intervalId != undefined) this.intervalId = data.intervalId;
            if ("type" in data && data.type != undefined) this.type = data.type;
            if ("date" in data && data.date != undefined) this.date = data.date;
        }
    }

    get id(): number {
        return Message.getField(this, 1) as number;
    }
    set id(value: number) {
        Message.setField(this, 1, value);
    }

    get trainingId(): number {
        return Message.getField(this, 2) as number;
    }
    set trainingId(value: number) {
        Message.setField(this, 2, value);
    }

    get intervalId(): number {
        return Message.getField(this, 3) as number;
    }
    set intervalId(value: number) {
        Message.setField(this, 3, value);
    }

    get type(): DocumentType {
        return Message.getField(this, 4) as DocumentType;
    }
    set type(value: DocumentType) {
        Message.setField(this, 4, value);
    }

    get date(): number {
        return Message.getField(this, 5) as number;
    }
    set date(value: number) {
        Message.setField(this, 5, value);
    }

    toObject(includeInstance: boolean = true) {
        const data = includeInstance ? new Document() : {} as Document;
        if (this.id != undefined) data.id = this.id;
        if (this.trainingId != undefined) data.trainingId = this.trainingId;
        if (this.intervalId != undefined) data.intervalId = this.intervalId;
        if (this.type != undefined) data.type = this.type;
        if (this.date != undefined) data.date = this.date;
        return data;
    }

    serialize(): Uint8Array
    serialize(w: BinaryWriter): undefined
    serialize(w?: BinaryWriter): Uint8Array | undefined {
        const writer = w || new BinaryWriter();
        try {
                if (this.id !== undefined) writer.writeInt32(1, this.id);
                if (this.trainingId !== undefined) writer.writeInt32(2, this.trainingId);
                if (this.intervalId !== undefined) writer.writeInt32(3, this.intervalId);
                if (this.type !== undefined) writer.writeEnum(4, this.type);
                if (this.date !== undefined) writer.writeInt64(5, this.date);
        
        } catch (e: any) {
            if (!w) console.error(e)
            throw e
        }
        if (!w) return writer.getResultBuffer();
    }

    serializeBinary(): Uint8Array {
        return this.serialize();
    }

    static serializeBinary(data?: IDocument): Uint8Array {
        return (data instanceof Message ? (data as MDocument) : new MDocument(data)).serializeBinary()
    }


    static deserialize(bytes: Uint8Array | BinaryReader): MDocument {
        const reader = bytes instanceof Uint8Array ? new BinaryReader(bytes) : bytes;
        const message = new MDocument();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
            case 1:
                    message.id = reader.readInt32();
                    break;
            case 2:
                    message.trainingId = reader.readInt32();
                    break;
            case 3:
                    message.intervalId = reader.readInt32();
                    break;
            case 4:
                    message.type = reader.readEnum();
                    break;
            case 5:
                    message.date = reader.readInt64();
                    break;
            
                default: reader.skipField();
            }
        }
        return message;
    }

    static override deserializeBinary(bytes: Uint8Array): MDocument {
        return MDocument.deserializeBinaryFromReader(new MDocument(), new BinaryReader(bytes));
    }

    static override deserializeBinaryFromReader(msg: MDocument, reader: BinaryReader) {
        return Object.assign(msg, MDocument.deserialize(reader))
    };

}
export interface IDocuments {
    values?: IDocument[];
    count?: number;

}
export class Documents implements IDocuments {

    values: Document[];
    count?: number;

    constructor(data?: Partial<IDocuments>) {
        if (data)
            Object.keys(data).forEach(d => this[d] = data[d])
    }
}
export class MDocuments extends Message implements Documents {

    constructor(data?: Partial<IDocuments>) {
        super();
        Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [1], []);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("values" in data && data.values != undefined) this.values = data.values.map(d => new MDocument(d));
            if ("count" in data && data.count != undefined) this.count = data.count;
        }
    }

    get values(): MDocument[] {
        return Message.getRepeatedWrapperField(this, MDocument, 1);
    }
    set values(value: MDocument[]) {
        Message.setRepeatedWrapperField(this, 1, value);
    }

    get count(): number {
        return Message.getField(this, 2) as number;
    }
    set count(value: number) {
        Message.setField(this, 2, value);
    }

    toObject(includeInstance: boolean = true) {
        const data = includeInstance ? new Documents() : {} as Documents;
        data.values = this.values.map(d => d.toObject(includeInstance));
        if (this.count != undefined) data.count = this.count;
        return data;
    }

    serialize(): Uint8Array
    serialize(w: BinaryWriter): undefined
    serialize(w?: BinaryWriter): Uint8Array | undefined {
        const writer = w || new BinaryWriter();
        try {
                if (this.values !== undefined) writer.writeRepeatedMessage(1, this.values, (i) => i.serialize(writer));
                if (this.count !== undefined) writer.writeInt32(2, this.count);
        
        } catch (e: any) {
            if (!w) console.error(e)
            throw e
        }
        if (!w) return writer.getResultBuffer();
    }

    serializeBinary(): Uint8Array {
        return this.serialize();
    }

    static serializeBinary(data?: IDocuments): Uint8Array {
        return (data instanceof Message ? (data as MDocuments) : new MDocuments(data)).serializeBinary()
    }


    static deserialize(bytes: Uint8Array | BinaryReader): MDocuments {
        const reader = bytes instanceof Uint8Array ? new BinaryReader(bytes) : bytes;
        const message = new MDocuments();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
            case 1:
                    reader.readMessage(message.values, () => Message.addToRepeatedWrapperField(message, 1, MDocument.deserialize(reader), MDocument));
                    break;
            case 2:
                    message.count = reader.readInt32();
                    break;
            
                default: reader.skipField();
            }
        }
        return message;
    }

    static override deserializeBinary(bytes: Uint8Array): MDocuments {
        return MDocuments.deserializeBinaryFromReader(new MDocuments(), new BinaryReader(bytes));
    }

    static override deserializeBinaryFromReader(msg: MDocuments, reader: BinaryReader) {
        return Object.assign(msg, MDocuments.deserialize(reader))
    };

}
                        




export default () => {}